import { Divider } from 'antd'

const DateAndTime = ({ text, oneLine }) => {
  return (
    <div className='w-[6.5rem]'>
      {text ? (
        <div className={`${oneLine ? 'flex gap-8' : ''}`}>
          <span className={`font-medium block text-black w-full`}>
            {text?.substr(0, 10).split('-').reverse().join('/')}
          </span>
          <span className='block text-[#6D6D6D]'>{text?.substr(11, 8)}</span>
        </div>
      ) : (
        <Divider className='border-[#DDD] my-0' />
      )}
    </div>
  )
}

export default DateAndTime
